import { withDisplayName } from '@hocs/with-display-name'
import LegalMentionsDialog from '@layouts/legal-mentions-dialog'
import RichText from '@resolvers/rich-text'
import { defaultRichTextFieldOptionsDeprecated } from '@resolvers/rich-text/default-rich-text-field-options-deprecated'
import { EnhancedLink } from '@ui/enhanced-components/enhanced-components'
import { formatDate } from '@utils/date'
import { graphql } from 'gatsby'
import React, { useState } from 'react'

const ContentfulOfferRefreshLanding: Utils.EntryFC<
  Queries.ContentfulOfferRefreshLandingFragment
> = ({
  content: {
    promoNumber,
    promoSymbol,
    baseLine,
    promoCode,
    promoTextV2,
    modalConditions,
    promoHighlightV2,
    promoBeginning,
    promoEnd,
    preBaseLine,
  },
  entryInspectorProps,
  fieldInspectorProps,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const close = () => {
    setIsOpen(false)
  }

  const open = () => {
    setIsOpen(true)
  }

  return (
    <div className="flex flex-col" {...entryInspectorProps()}>
      <div className="mt-8">
        {promoEnd && (
          <p className="text-095 pb-2">
            {promoBeginning ? `Du ` : "Jusqu'"}
            {promoBeginning && (
              <span className="font-medium">{formatDate(promoBeginning)} </span>
            )}
            {'au '}
            <span className="font-medium">{formatDate(promoEnd)}</span>
          </p>
        )}
        <div className="flex flex-wrap text-[48px]/[57.6px] font-medium laptop:text-[56px]/[68px]">
          {preBaseLine && (
            <span
              {...fieldInspectorProps({
                fieldId: 'preBaseLine',
              })}
            >
              {preBaseLine}&nbsp;
            </span>
          )}
          {promoNumber && (
            <span
              {...fieldInspectorProps({
                fieldId: 'promoNumber',
              })}
            >
              {promoNumber}
            </span>
          )}
          {promoSymbol && (
            <span
              {...fieldInspectorProps({
                fieldId: 'promoSymbol',
              })}
            >
              {promoSymbol}
            </span>
          )}
          {baseLine && (
            <span
              {...fieldInspectorProps({
                fieldId: 'baseline',
              })}
            >
              &nbsp;{baseLine}
            </span>
          )}
        </div>
      </div>
      {promoHighlightV2 && (
        <div className="mb-3 mt-3 text-150 font-medium">
          <RichText
            {...fieldInspectorProps({
              fieldId: 'promoHighlightV2',
            })}
            content={promoHighlightV2}
            options={defaultRichTextFieldOptionsDeprecated}
          />
        </div>
      )}
      {promoTextV2 && (
        <RichText
          {...fieldInspectorProps({
            fieldId: 'promoTextV2',
          })}
          content={promoTextV2}
          options={defaultRichTextFieldOptionsDeprecated}
        />
      )}
      {modalConditions && (
        <div>
          <EnhancedLink onClick={open}>Voir conditions</EnhancedLink>
          <LegalMentionsDialog
            legalMentions={modalConditions}
            visible={isOpen}
            onClose={close}
          />
        </div>
      )}
      {promoCode && (
        <p className="pt-12 text-085">
          Avec le code opération :{' '}
          <span
            className="px-1 py-1 leading-[2rem]"
            {...fieldInspectorProps({
              fieldId: 'promoCode',
            })}
          >
            <strong>{promoCode}</strong>
          </span>
        </p>
      )}
    </div>
  )
}

export const query = graphql`
  fragment ContentfulOfferRefreshLanding on Contentful10SSpX3YFi0CgK40EseM2G {
    ...ContentfulEntry
    category {
      text
    }
    preBaseLine
    baseLine
    modalConditions {
      rich
      references {
        ...ContentfulFootnoteSup
      }
    }
    promoBeginning
    promoEnd
    promoCode
    promoHighlightV2 {
      rich
      references {
        ...ContentfulFootnoteSup
      }
    }
    promoNumber
    promoSymbol
    promoTextV2 {
      rich
      references {
        ...ContentfulFootnoteSup
      }
    }
  }
`

export default withDisplayName(
  ContentfulOfferRefreshLanding,
  'ContentfulOfferRefreshLanding'
)
